import { RegisterModule } from '@/typings/common'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import {
  LKPassportState,
  LKPassportGetters,
  LKPassportMutations,
  LKPassportActions,
} from './store'
import { MODULE_NAME } from '../utils'

const storeModule = (
  new Module({
    namespaced: true,
    state: LKPassportState,
    getters: LKPassportGetters,
    mutations: LKPassportMutations,
    actions: LKPassportActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as LKPassportStoreModule,
  mapper as LKPassportMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
